import TourActivationReadinessDto from '@/features/dashboard/tours/types/TourActivationReadinessDto.ts';

/** Powody, dla których szkicu nie da się aktywować — te same fasety, które sprawdza backend przy aktywacji. */
export const activationBlockers = (
  readiness: TourActivationReadinessDto,
): string[] => {
  const reasons: string[] = [];
  if (!readiness.hasPrices) reasons.push('Dodaj cennik do wyjazdu');
  if (!readiness.hasInstallments) reasons.push('Dodaj raty do wyjazdu');
  if (!readiness.hasTransportDeclaration)
    reasons.push('Zapisz konfigurację transportu wyjazdu');
  if (!readiness.tfgReady)
    reasons.push('Uzupełnij ustawienia TFG i typ transportu każdego wariantu');
  return reasons;
};
